import Highcharts from 'highcharts'
import map from 'highcharts/modules/map'
import jpAll from '@highcharts/map-collection/countries/jp/jp-all.topo.json'
import worldMap from '@highcharts/map-collection/custom/world.topo.json'

// Highcharts Mapモジュールを初期化
// map(Highcharts)

// 日本地図を作成
function createJapanMap(containerId, audienceData) {
  const container = document.getElementById(containerId)
  if (!container) return


  // データフォーマットを変換
  // 県名は Ruby 側（JapanPrefecture）で地図データの properties.name と同じ表記に
  // 正規化済みのため、joinBy: 'name' でそのまま結合する
  const data = audienceData.map((item) => {
    const [name, value] = Array.isArray(item) ? item : [item.name || '', item.value || 0]

    return { name: name, value: value }
  })

  // Highcharts Map を作成
  Highcharts.mapChart(containerId, {
    chart: {
      map: jpAll,
      height: 600,
      backgroundColor: 'transparent'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      title: {
        text: 'フォロワー数'
      }
    },
    colorAxis: {
      min: 0,
      minColor: '#F0F9FF',
      maxColor: '#1E40AF',
      labels: {
        formatter: function() {
          return this.value.toLocaleString()
        }
      }
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom'
      }
    },
    tooltip: {
      formatter: function() {
        const point = this.point || this
        return '<b>' + point.name + '</b><br/>' +
               'フォロワー数: ' + (point.value || 0).toLocaleString() + '人'
      }
    },
    series: [{
      data: data,
      name: 'フォロワー分布',
      joinBy: 'name',
      states: {
        hover: {
          brightness: 0.1
        }
      },
      dataLabels: {
        enabled: false
      }
    }]
  })
}

// 世界地図を作成
function createWorldMap(containerId, audienceData) {
  const container = document.getElementById(containerId)
  if (!container) return

  // データフォーマットを変換
  const data = audienceData.map(([name, value]) => {
    // 国名をHighchartsのコードに変換（必要に応じて追加）
    const countryCodeMap = {
      'Japan': 'jp',
      'United States': 'us',
      'China': 'cn',
      'Korea': 'kr',
      'South Korea': 'kr',
      'United Kingdom': 'gb',
      'France': 'fr',
      'Germany': 'de',
      'India': 'in',
      'Canada': 'ca',
      'Australia': 'au',
      'Brazil': 'br',
      'Indonesia': 'id',
      'Thailand': 'th',
      'Vietnam': 'vn',
      'Philippines': 'ph',
      'Malaysia': 'my',
      'Singapore': 'sg',
      'Taiwan': 'tw',
      'Hong Kong': 'hk',
      'Mexico': 'mx',
      'Italy': 'it',
      'Spain': 'es',
      'Russia': 'ru',
      'Netherlands': 'nl',
      'Belgium': 'be',
      'Switzerland': 'ch',
      'Sweden': 'se',
      'Norway': 'no',
      'Denmark': 'dk',
      'Finland': 'fi',
      'Poland': 'pl',
      'Austria': 'at',
      'New Zealand': 'nz',
      'Argentina': 'ar',
      'Chile': 'cl',
      'Colombia': 'co',
      'Peru': 'pe',
      'Venezuela': 've',
      'South Africa': 'za',
      'Egypt': 'eg',
      'Turkey': 'tr',
      'Saudi Arabia': 'sa',
      'United Arab Emirates': 'ae',
      'Israel': 'il',
      'Portugal': 'pt',
      'Greece': 'gr',
      'Czech Republic': 'cz',
      'Hungary': 'hu',
      'Romania': 'ro',
      'Ukraine': 'ua',
      'Pakistan': 'pk',
      'Bangladesh': 'bd',
      'Nigeria': 'ng',
      'Kenya': 'ke',
      'Morocco': 'ma'
    }
    
    return {
      'hc-key': countryCodeMap[name] ? countryCodeMap[name].toLowerCase() : name.toLowerCase().replace(/\s+/g, '-'),
      value: value
    }
  })

  // Highcharts Map を作成
  Highcharts.mapChart(containerId, {
    chart: {
      map: worldMap,
      height: 600,
      backgroundColor: 'transparent'
    },
    mapView: {
      center: [0, 0],
      zoom: 1.5
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      title: {
        text: 'フォロワー数'
      }
    },
    colorAxis: {
      min: 0,
      minColor: '#F0F9FF',
      maxColor: '#1E40AF',
      labels: {
        formatter: function() {
          return this.value.toLocaleString()
        }
      }
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom'
      }
    },
    tooltip: {
      formatter: function() {
        const point = this.point || this
        return '<b>' + point.name + '</b><br/>' +
               'フォロワー数: ' + (point.value || 0).toLocaleString() + '人'
      }
    },
    series: [{
      data: data,
      name: 'フォロワー分布',
      joinBy: 'hc-key',
      states: {
        hover: {
          brightness: 0.1
        }
      },
      dataLabels: {
        enabled: false
      }
    }]
  })
}

// 地図の初期化フラグ
let mapsInitialized = {
  japan: false,
  world: false
}

// Turbo対応の初期化
document.addEventListener('turbo:load', () => {
  // フラグをリセット
  mapsInitialized = {
    japan: false,
    world: false
  }
  
  // 日本地図（初期表示）
  const japanMapElement = document.getElementById('japan-highcharts-map')
  if (japanMapElement && !mapsInitialized.japan) {
    const audienceData = JSON.parse(japanMapElement.dataset.audienceData || '[]')
    createJapanMap('japan-highcharts-map', audienceData)
    mapsInitialized.japan = true
  }

  // タブ切り替えの処理
  const mapTabs = document.querySelectorAll('[data-map-tab]')
  const mapContents = document.querySelectorAll('[data-map-content]')
  
  mapTabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      const targetMap = e.target.dataset.mapTab
      
      // タブのスタイルを更新
      mapTabs.forEach(t => {
        t.classList.remove('btn-primary')
        t.classList.add('btn-ghost')
      })
      e.target.classList.remove('btn-ghost')
      e.target.classList.add('btn-primary')
      
      // コンテンツの表示切り替え
      mapContents.forEach(content => {
        if (content.dataset.mapContent === targetMap) {
          content.classList.remove('hidden')
        } else {
          content.classList.add('hidden')
        }
      })
      
      // 世界地図を初めて表示する場合は初期化
      if (targetMap === 'world' && !mapsInitialized.world) {
        const worldMapElement = document.getElementById('world-highcharts-map')
        if (worldMapElement) {
          const audienceData = JSON.parse(worldMapElement.dataset.audienceData || '[]')
          // 少し遅延させて確実に表示されてから初期化
          setTimeout(() => {
            createWorldMap('world-highcharts-map', audienceData)
            mapsInitialized.world = true
          }, 100)
        }
      }
    })
  })
})
